import React from 'react'
import ViewContainer from '../../../../component/organization/view-organization/ViewContainer'

function ViewOrganization() {
  return (
    <div className='page-body'>
      <ViewContainer/>
    </div>
  )
}

export default ViewOrganization
